import { convertValues } from '~/util';

import { client } from './client';

export interface InterestPayout {
  id: string;
  createdAt: string;
  updatedAt: string;
  productType: string;
  type: 'credit' | 'debit';
  productId: string;
  relatedProductId?: string;
  lastAccruedDate: string;
  amount: string;
  currencyCode: string;
  description?: string;
}

interface ListInterestPayoutsResponse {
  payouts: InterestPayout[];
  hasMore: boolean;
}

export interface InterestConfig {
  id: string;
  productType: string;
  description?: string;
  accrualMethod: string;
  effectiveDate?: string;
  effectiveAfterDays?: number;
  ceilingRate?: string;
  floorRate?: string;
  isNotWaterfall: boolean;
  tiers: InterestConfigTier[];
  pivotRate?: {
    id: string;
    rate: string;
    effectiveDate: string;
  };
}

export interface InterestConfigTier {
  threshold: string;
  fixedRate?: string;
  pivotPercentage?: string;
  pivotRelative?: string;
}

export class InterestRepository {
  static async getPayout(id: string) {
    return client
      .get<unknown, InterestPayout>(`/interests/payouts/${id}`)
      .then((response) => convertValues<InterestPayout>(response));
  }

  static async getAllPayouts(query?: Record<string, any>) {
    return client
      .get<Record<string, any>, ListInterestPayoutsResponse>('/interests/payouts', { query })
      .then((response) => ({
        payouts: Array.isArray(response?.payouts) ? response.payouts.map((e) => convertValues<InterestPayout>(e)) : [],
        hasMore: Boolean(response?.hasMore),
      }));
  }

  static async getConfig(id: string, accrualDate?: string) {
    const query = accrualDate ? { accrual_date: accrualDate } : undefined;
    return client
      .get<Record<string, any>, InterestConfig>(`/interests/configs/${id}`, { query })
      .then((response) => convertValues<InterestConfig>(response));
  }
}
